// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/product_categories/salvar
 *
 * Returns the saved category's id (create or update).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ProductCategories_SalvarResponseDados {
so_product_category_id: number
}

export type ProductCategories_SalvarResponse = ApiResponse<ProductCategories_SalvarResponseDados>;

registerResponseContract('ProductCategories_SalvarResponse', {
  so_product_category_id: { type: 'number',  required: true },
})
